export class FocalAreaUtils {
	/**
	 * Calculate aspect ratio from bounding box dimensions
	 * Returns a simplified ratio string like "16:9" or "1:1"
	 */
	public static calculateAspectRatio(width: number, height: number): string {
		if (width === 0 || height === 0) return '1:1';

		const gcd = (a: number, b: number): number => {
			if (isNaN(a) || isNaN(b)) return 1;

			a = Math.floor(Math.abs(a));
			b = Math.floor(Math.abs(b));
			while (b !== 0) {
				const temp = b;
				b = a % b;
				a = temp;
			}
			return a;
		};

		// Round to avoid floating point precision issues
		const w = Math.round(width * 100);
		const h = Math.round(height * 100);
		const divisor = gcd(w, h);

		const ratioW = w / divisor;
		const ratioH = h / divisor;

		// Simplify common ratios
		if (Math.abs(ratioW - ratioH) < 0.1) return '1:1';
		if (Math.abs(ratioW / ratioH - 16 / 9) < 0.1) return '16:9';
		if (Math.abs(ratioW / ratioH - 9 / 16) < 0.1) return '9:16';
		if (Math.abs(ratioW / ratioH - 4 / 3) < 0.1) return '4:3';
		if (Math.abs(ratioW / ratioH - 3 / 4) < 0.1) return '3:4';

		// Return simplified ratio
		return `${ratioW.toFixed(1)}:${ratioH.toFixed(1)}`;
	}
}
